/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Brief_Squid_LockInputs */

const fr_plain_brief_squid_lock = /** @type {(inputs: Plain_Brief_Squid_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editer Cours`)
};

/**

* @param {Plain_Brief_Squid_LockInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const plain_brief_squid_lock = /** @type {((inputs?: Plain_Brief_Squid_LockInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Brief_Squid_LockInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_plain_brief_squid_lock(inputs)
});